import { FONT_SECONDARY } from "@/theme/typography";
import { Theme } from "@mui/material";

export const popUpStyles = {
  "&::-webkit-scrollbar": {
    width: "6px",
    backgroundColor: "#f5f5f5",
  },
  "&::-webkit-scrollbar-track": {
    background: "#fff",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "lightgray",
    borderRadius: "20px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "gray",
    cursor: "pointer",
  },
};

export const getIconButtonStyles = (theme: Theme, isActivePage: boolean) => ({
  position: "relative",
  display: "flex",
  "& svg": {
    stroke: isActivePage ? theme.palette.primary.main : "#0F172A",
  },
});

export const getButtonStyles = (theme: Theme, isActivePage: boolean) => ({
  position: "relative",
  display: "flex",

  borderColor: "transparent",
  fontFamily: FONT_SECONDARY,
  color: isActivePage ? `${theme.palette.primary.main} !important` : "#0F172A",

  "& svg": {
    stroke: isActivePage ? theme.palette.primary.main : "#0F172A",
  },
});

export const getLabelStyles = (isIconButton: boolean, isTablet: boolean) => ({
  position: "absolute",
  top: isIconButton && isTablet ? 7 : 10,
  right: isIconButton ? 12 : 57,
  width: 12,
  height: 12,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  bgcolor: "background.default",
  borderRadius: "50%",
});

export const circleStyles = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  bgcolor: "primary.main",
};
